export default "__VITE_ASSET__Dai9Xg36__"